import Http from '@/services/http';
import { SupervisionSensorChart, ChartQuery } from 'sigma-mappings';

const urls = {
  base: moduleAssetId => `/Supervisao/${moduleAssetId}/grafico`,
};

export default {
  getData(moduleAssetId, chartFilters) {
    const http = new Http();
    const chartQuery = new ChartQuery(chartFilters);
    return http.get(urls.base(moduleAssetId), { params: chartQuery })
      .then(({ data }) => data.map(item => new SupervisionSensorChart(item)));
  },
};
